/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Template
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import { BatchRecognitionMetadata } from './batch-recognition-metadata';
// May contain unused imports in some cases
// @ts-ignore
import { BatchRecognitionResult } from './batch-recognition-result';
// May contain unused imports in some cases
// @ts-ignore
import { Chapter } from './chapter';
// May contain unused imports in some cases
// @ts-ignore
import { JobInfo } from './job-info';
// May contain unused imports in some cases
// @ts-ignore
import { SentimentAnalysisResult } from './sentiment-analysis-result';
// May contain unused imports in some cases
// @ts-ignore
import { SummarizationResult } from './summarization-result';
// May contain unused imports in some cases
// @ts-ignore
import { TopicDetectionResult } from './topic-detection-result';
// May contain unused imports in some cases
// @ts-ignore
import { TranslationSentence } from './translation-sentence';

/**
 *
 * @export
 * @interface RetrieveTranscriptResponse
 */
export interface RetrieveTranscriptResponse {
  /**
   * An array of objects that represent summarized chapters of the transcript
   * @type {Array<Chapter>}
   * @memberof RetrieveTranscriptResponse
   */
  chapters?: Array<Chapter>;
  /**
   * Speechmatics JSON transcript format version number.
   * @type {string}
   * @memberof RetrieveTranscriptResponse
   */
  format: string;
  /**
   *
   * @type {JobInfo}
   * @memberof RetrieveTranscriptResponse
   */
  job: JobInfo;
  /**
   *
   * @type {BatchRecognitionMetadata}
   * @memberof RetrieveTranscriptResponse
   */
  metadata: BatchRecognitionMetadata;
  /**
   *
   * @type {Array<BatchRecognitionResult>}
   * @memberof RetrieveTranscriptResponse
   */
  results: Array<BatchRecognitionResult>;
  /**
   *
   * @type {SentimentAnalysisResult}
   * @memberof RetrieveTranscriptResponse
   */
  sentiment_analysis?: SentimentAnalysisResult;
  /**
   *
   * @type {SummarizationResult}
   * @memberof RetrieveTranscriptResponse
   */
  summary?: SummarizationResult;
  /**
   *
   * @type {TopicDetectionResult}
   * @memberof RetrieveTranscriptResponse
   */
  topics?: TopicDetectionResult;
  /**
   * Translations of the transcript into other languages. It is a map of ISO language codes to arrays of translated sentences. Configured using `translation_config`.
   * @type {{ [key: string]: Array<TranslationSentence>; }}
   * @memberof RetrieveTranscriptResponse
   */
  translations?: { [key: string]: Array<TranslationSentence> };
}
